export default __webpack_public_path__ + "static/media/taklif1.0ab752b7.svg";